import axios from "axios";
import apiUrlOne from "../../utils.js/Config";

// FAQ Types
export const getFaqTypes = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/faqs-types`);
        return response.data;
    } catch (error) {
        console.error('Error fetching FAQ types:', error);
        throw error;
    }
};

export const createFaqType = async (data) => {
    try {
        const response = await axios.post(`${apiUrlOne}/faqs-types`, data);
        return response.data;
    } catch (error) {
        console.error('Error creating FAQ type:', error);
        throw error;
    }
};

export const updateFaqType = async (id, data) => {
    try {
        const response = await axios.put(`${apiUrlOne}/faqs-types/${id}`, data);
        return response.data;
    } catch (error) {
        console.error('Error updating FAQ type:', error);
        throw error;
    }
};

export const getFaqTypeById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/faqs-types/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching FAQ type with ID ${id}:`, error);
        throw error;
    }
};

export const getFaqTypeByCategoryId = async (categoryId) => {
    try {
        const response = await axios.get(`${apiUrlOne}/faqs-types/category/${categoryId}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching FAQ types for category ${categoryId}:`, error);
        throw error;
    }
};

export const getFaqsByTypeId = async (typeId) => {
    try {
        const response = await axios.get(`${apiUrlOne}/faqs/type/${typeId}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching FAQs for type ID ${typeId}:`, error);
        throw error;
    }
};

// FAQs (QnA)
export const getFaqs = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/faqs`);
        return response.data;
    } catch (error) {
        console.error('Error fetching FAQs:', error);
        throw error;
    }
};

export const createFaq = async (data) => {
    try {
        const response = await axios.post(`${apiUrlOne}/faqs`, data);
        return response.data;
    } catch (error) {
        console.error('Error creating FAQ:', error);
        throw error;
    }
};

export const updateFaq = async (id, data) => {
    try {
        const response = await axios.put(`${apiUrlOne}/faqs/${id}`, data);
        return response.data;
    } catch (error) {
        console.error('Error updating FAQ:', error);
        throw error;
    }
};

export const deleteFaqType = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/faqs-types/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error deleting FAQ type with ID ${id}:`, error);
        throw error;
    }
};

export const deleteFaq = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/faqs/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error deleting FAQ with ID ${id}:`, error);
        throw error;
    }
};
